import Ellipsis from "@/components/views/Ellipsis";
import { paginationTableProps, tableStandardProps } from "@/utils/componentUtils";
import { formatLocaleDate } from "@/utils/formatUtils";
import { numberOrZero } from "@/utils/utils";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TableSizes } from "../../../common/constants";
import { PageResult } from "../../../common/types";
import { HistoryLog } from "../types";

type Props = {
  data?: PageResult<HistoryLog>;
  onChangePage: (pageIndex: number) => void;
  loading: boolean;
};

export const HistoryLogTable = ({ data, onChangePage, loading }: Props) => {
  const { t } = useTranslation();

  const columns: ColumnsType<HistoryLog> = useMemo(
    () => [
      {
        key: "item",
        title: t("historyLog.attrs.item"),
        width: 150,
        ellipsis: { showTitle: false },
        render: (_, record) => <Ellipsis>{record.item}</Ellipsis>,
      },
      {
        key: "validFrom",
        title: t("historyLog.attrs.validFrom"),
        width: 95,
        render: (_, record) => (record.validFrom ? formatLocaleDate(record.validFrom) : undefined),
      },
      {
        key: "validTo",
        title: t("historyLog.attrs.validTo"),
        width: 95,
        render: (_, record) => (record.validTo ? formatLocaleDate(record.validTo) : undefined),
      },
      {
        key: "type",
        title: t("historyLog.attrs.type"),
        width: 130,
        ellipsis: { showTitle: false },
        render: (_, record) => <Ellipsis>{record.type}</Ellipsis>,
      },
      {
        key: "description",
        title: t("historyLog.attrs.description"),
        width: 200,
        ellipsis: { showTitle: false },
        render: (_, record) => <Ellipsis>{record.description}</Ellipsis>,
      },
      {
        key: "changeDate",
        title: t("historyLog.attrs.changeDate"),
        width: 95,
        render: (_, record) => (record.changeDate ? formatLocaleDate(record.changeDate) : undefined),
      },
      {
        key: "changeBy",
        title: t("historyLog.attrs.changeBy"),
        width: 135,
        ellipsis: { showTitle: false },
        render: (_, record) => <Ellipsis>{record.changedBy}</Ellipsis>,
      },
    ],
    [],
  );

  return (
    <Table<HistoryLog>
      {...tableStandardProps()}
      loading={loading}
      columns={columns}
      scroll={{ x: TableSizes.MEDIUM }}
      dataSource={data?.pageData}
      pagination={{
        ...paginationTableProps,
        current: numberOrZero(data?.pageIndex) + 1,
        pageSize: data?.pageSize,
        total: data?.totalElementsCount,
        onChange: (pageIndex) => onChangePage(pageIndex - 1),
      }}
    />
  );
};
